<div class="document-viewer">
	<!-- Loading -->
	<div *ngIf="loading" class="flex items-center justify-center py-12">
		<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
		<span class="ml-3 text-gray-600">Chargement du document...</span>
	</div>

	<!-- Error -->
	<div *ngIf="error" class="text-center py-8">
		<div class="text-red-500 mb-4">
			<svg class="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
					d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
			</svg>
		</div>
		<h3 class="text-lg font-medium text-gray-900 mb-2">
			Erreur de chargement
		</h3>
		<p class="text-gray-600">{{ error }}</p>
	</div>

	<!-- Document Viewer -->
	<div *ngIf="!loading && !error && documentUrl" class="document-container h-full">
		<!-- PDF Viewer -->
		<iframe *ngIf="isPdf" [src]="documentUrl | safe" class="w-full h-128 border border-gray-300 rounded-lg"
			frameborder="0">
		</iframe>

		<!-- Image Viewer -->
		<div *ngIf="isImage" class="text-center">
			<img [src]="documentUrl" [alt]="document?.filename"
				class="max-w-full max-h-96 mx-auto border border-gray-300 rounded-lg" />
		</div>

		<!-- Fallback for other file types -->
		<div *ngIf="!isPdf && !isImage" class="text-center py-8">
			<div class="text-gray-400 mb-4">
				<svg class="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
				</svg>
			</div>
			<h3 class="text-lg font-medium text-gray-900 mb-2">
				Aperçu non disponible
			</h3>
			<p class="text-gray-600 mb-4">
				Ce type de fichier ne peut pas être prévisualisé.
			</p>
			<a [href]="documentUrl" target="_blank"
				class="inline-flex items-center px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90">
				Ouvrir dans un nouvel onglet
			</a>
		</div>
	</div>
</div>